import { config } from "src/stateManagement/redux/configVar";
import { ActivePlanningActivity } from "src/tecnica/pages/dashboard/reports/close_daily/updateTaskModal";


export const updatePlanningActivityStatus = async (activePlanningActivity: ActivePlanningActivity) => {
    try {

        let token = localStorage.getItem("authToken");

        const serverUrl = config.serverUrl

        const headers: any = {
            "Content-Type": "application/json",
            authorization: `${token}`,
        }

        console.log("antes de la query")

        const response = await fetch(`${serverUrl}/api/planning/updatePlanningActivityStatus`, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(activePlanningActivity)
        });

        if (response?.status === 401) {
            return;
        }

        if (response?.status !== 200 && response?.status !== 201) {
            return;
        }

        const data = await response.json();

        return data;

    } catch (error) {
        console.log({ error })
    }
}


export const updatePlanningActivity = async (task: any) => {
    try {
        let token = localStorage.getItem("authToken");

        const serverUrl = config.serverUrl

        const headers: any = {
            "Content-Type": "application/json",
            authorization: `${token}`,
        }

        const response = await fetch(`${serverUrl}/api/planning/updatePlanningActivity`, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(task)
        });

        const json = await response.json();

        return json;

    } catch (error) {
        console.log({ error })
    }

}

export interface OptimizationActivitiesSelected {
    id: string;
    name: string;
    simulated: boolean;
    optimizationActivityId: string;
    main: boolean;
}

export interface UpdateDiagnosticForActivity {
    originFieldActivityIds: string[];
    projectId: string;
    locationId: string;
    diagnostic: string;
    recommendation: string;
    candidateSate: string;
    bottomHoleCondition: string;
    requiredUserId: string;
    executedAt:Date;
    subBottomHoleCondition: string;
    bottomHoleFillage: number;
    ept:number
    theoricalProduction: number;
    pumpEfficiency: number;
    adjustProduction:number;
    mpt:number;
    dplunger:number;
    newFieldActivityState: string;
    optimizationActivitiesSelected: OptimizationActivitiesSelected[];

}

export const updateUpdateDiagnosticForActivity= async(analyst: UpdateDiagnosticForActivity) => {
    try {
        let token = localStorage.getItem("authToken");

        const serverUrl = config.serverUrl

        const headers: any = {
            "Content-Type": "application/json",
            authorization: `${token}`,
        }

        const response = await fetch(`${serverUrl}/api/operations/addDiagnosticActivities`, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(analyst)
        });

        const json = await response.json();

        return json;

    } catch (error) {
        console.log({ error })
    }
}

export const updateFieldVariablesValues = async (fieldVariables: any) => {
    try {
        let token = localStorage.getItem("authToken");

        const serverUrl = config.serverUrl

        const headers: any = {
            "Content-Type": "application/json",
            authorization: `${token}`,
        }

        const response = await fetch(`${serverUrl}/api/operations/updateFieldActivityVariable`, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(fieldVariables)
        });

        if (response?.status !== 200 && response?.status !== 201) {
            throw new Error(`Error Cargando los datos: ${response.status}`);
        }

        const json = await response.json();

        return json;

    } catch (error) {
        console.log({ error })
        throw new Error(`Error Cargando los datos: ${error}`);
    }
}